module.exports = __webpack_public_path__ + "img/0c2253cb-cbf9-4484-b140-b3519d0ffb01.37887b87.png";